var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSnackbarItems.length != 0)?_c('div',{staticClass:"snackbar"},_vm._l((_vm.getSnackbarItems),function(item){return _c('span',{key:item.id,class:`${item.type}`},[_vm._v(_vm._s(item.text))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }